"use client";

import { buildControllerRules } from "@gettactic/helpers/src/hook-form/buildControllerRules";
import React from "react";
import { Controller, FieldValues } from "react-hook-form";
import { AsyncUserSelectInput } from "./AsyncUserSelectInput";
import { HookFormAsyncUserSelectInputProps } from "./UserSelectInput.types";

/**
 * react-hook-form binding for {@link AsyncUserSelectInput}. Prefer this over
 * `HookFormUserSelectInput` whenever the pool is the whole organization.
 */
export const HookFormAsyncUserSelectInput = <T extends FieldValues>({
  form,
  name,
  rules,
  onChange,
  multiselect = false,
  ...props
}: HookFormAsyncUserSelectInputProps<T>): React.ReactElement => {
  return (
    <Controller
      control={form.control}
      name={name}
      rules={buildControllerRules({
        form,
        name,
        rules,
        isRequired: props.isRequired
      })}
      render={({ field, fieldState }) => {
        if (multiselect) {
          const values = Array.isArray(field.value) ? field.value : [];
          return (
            <AsyncUserSelectInput
              ref={field.ref}
              {...props}
              multiselect={true}
              values={values}
              onChangeValues={(newValues) => {
                field.onChange(newValues);
                onChange?.(newValues);
              }}
              error={fieldState.error?.message}
            />
          );
        }
        const value = typeof field.value === "string" ? field.value : "";
        return (
          <AsyncUserSelectInput
            ref={field.ref}
            {...props}
            multiselect={false}
            value={value}
            onChangeValue={(newValue) => {
              field.onChange(newValue);
              onChange?.(newValue);
            }}
            error={fieldState.error?.message}
          />
        );
      }}
    />
  );
};
